
namespace RioERP.Products {
    export class ProductBillingItemsColumns {
        static columnsKey = 'Products.ProductBillingItems';
    }
}